module.exports = __webpack_public_path__ + "img/SaraK.15d7789.png";